<template>
  <div>
    <h4>{{ $t('reporting.potentialForOptimization') }}</h4>
    <DataTable
      :values="projectData"
      :rows="[
        { name: $t('reporting.projectFillLevel.group'), slot: 'link' },
        { name: $t('reporting.projectFillLevel.average'), slot: 'average', style: 'align-right' },
        { name: $t('reporting.projectFillLevel.recommendation.title'), slot: 'recommendation', style: 'align-right' },
      ]"
      :layoutFixed="false"
    >
      <template #link="{ value }">
        <Link :to="`/container_groups/${value.group_uuid}`">{{ value.group_name }}</Link>
      </template>
      <template #average="{ value }">
        <span :class="fillLevelColorClass(value.average_fill_level)">
          {{ (value.average_fill_level * 100).toFixed(1) }} %</span
        >
      </template>
      <template #recommendation="{ value }">
        {{ recommendationText(value) }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable/index.vue'

export default {
  name: 'ProjectFillLevel',
  components: {
    DataTable,
  },
  props: {
    projectData: { type: Array, required: true },
  },
  methods: {
    fillLevelColorClass(value) {
      if (value < 0.5 || value > 1.0) return 'color--warning'
      return 'color--normal'
    },
    recommendationText(value) {
      if (value.average_fill_level > 1.0)
        return this.$t('reporting.projectFillLevel.recommendation.shortenEmptyingInterval')
      if (value.average_fill_level < 0.5)
        return this.$t('reporting.projectFillLevel.recommendation.extendEmptyingInterval')
      return '-'
    },
  },
}
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 0;
  margin-bottom: 0.75rem;
}
.color--warning {
  color: var(--binity-red);
}
.color--normal {
  color: var(--binity-blue);
}
</style>
